import { createFileRoute, redirect } from "@tanstack/react-router";

import { getCurrentStoreStatusFn } from "@/server-fns/admin/storeFns";

export const Route = createFileRoute("/app/")({
    head: () => ({
        meta: [{ name: "robots", content: "noindex, nofollow" }],
    }),
    beforeLoad: async () => {
        const status = await getCurrentStoreStatusFn();
        if (status.status === "unauthenticated") {
            throw redirect({ to: "/signin" });
        }
        if (status.status === "no-store" || status.status === "in-progress") {
            throw redirect({ to: "/onboarding" });
        }
        throw redirect({
            to: "/app/$storeId",
            params: { storeId: status.store.id },
            search: { date: undefined, bookingId: undefined },
        });
    },
    component: () => null,
});
